module.exports = __webpack_public_path__ + "static/media/CV.c2194f79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/CV.svg
// module id = 2135
// module chunks = 7